import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["statesContainer", "template"]

    get nextTasksForValue() {
        const raw = this.data.get("nextTasksForValue")
        if (raw) {
            try { return JSON.parse(raw) } catch (e) { /* fall through */ }
        }
        return ["TaskCompletingState"]
    }

    addState(e) {
        e.preventDefault()
        let content = this.templateTarget.innerHTML
        content = content.replace(/NEW_INDEX/g, this.nextIndex())
        this.statesContainerTarget.insertAdjacentHTML("beforeend", content)
    }

    // Monotonic per-controller index: two rows added within the same
    // millisecond must still get distinct nested-attribute keys.
    nextIndex() {
        this.lastIndex = Math.max((this.lastIndex || 0) + 1, new Date().getTime())
        return this.lastIndex
    }

    removeState(e) {
        e.preventDefault()
        e.target.closest("[data-state-row]").remove()
    }

    toggleNextTasks(e) {
        const row = e.target.closest("[data-state-row]")
        const nextTasksDiv = row.querySelector("[data-next-tasks]")
        if (this.nextTasksForValue.includes(e.target.value)) {
            nextTasksDiv.classList.remove("hidden")
        } else {
            nextTasksDiv.classList.add("hidden")
            const select = nextTasksDiv.querySelector("select")
            if (select) {
                select.selectedIndex = -1
            }
        }
    }
}
